import {Icon, IconProps} from '@chakra-ui/react';

export function BallIcon(props: IconProps) {
  return (
    <Icon width="66px" height="66px" viewBox="0 0 66 66" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33 64.5184C50.4072 64.5184 64.5185 50.4071 64.5185 32.9999C64.5185 15.5927 50.4072 1.48145 33 1.48145C15.5927 1.48145 1.48145 15.5927 1.48145 32.9999C1.48145 50.4071 15.5927 64.5184 33 64.5184Z"
        fill="#FEFEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.5134 4.06934L47.5382 14.5093L59.526 15.9869C56.1589 10.7472 51.2865 6.57019 45.5134 4.06934Z"
        fill="#4C4C4C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.2783 50.3995C62.5871 45.4126 64.5181 39.4331 64.5181 33.0002C64.5181 32.3236 64.4895 31.655 64.448 30.9893L55.1418 37.7915L59.2783 50.3995Z"
        fill="#4C4C4C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.3819 62.3909L33.2209 54.6611L22.5962 62.7524C25.8546 63.8922 29.3531 64.5184 32.9997 64.5184C37.0147 64.5184 40.8499 63.7598 44.3819 62.3909Z"
        fill="#4C4C4C"
      />
      <path
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.7045 6.86279C54.0103 11.8487 55.9403 17.8253 55.9403 24.2562C55.9403 41.6634 41.829 55.7746 24.4217 55.7746C17.9918 55.7746 12.0142 53.8447 7.0293 50.5378C12.673 59.0488 22.3347 64.6639 33.311 64.6639C50.7183 64.6639 64.8296 50.5527 64.8296 33.1455C64.8296 22.1682 59.2155 12.5065 50.7045 6.86279Z"
        fill="#010202"
      />
      <mask
        id="mask0_5830_72374"
        style={{maskType: 'alpha'}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="66"
        height="66"
      >
        <path d="M0.000244141 65.9998H65.9993V0H0.000244141V65.9998Z" fill="white" />
      </mask>
      <g mask="url(#mask0_5830_72374)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M33.0003 2.9631C16.4376 2.9631 2.96335 16.4373 2.96335 33C2.96335 49.5617 16.4376 63.0369 33.0003 63.0369C49.5631 63.0369 63.0364 49.5617 63.0364 33C63.0364 16.4373 49.5631 2.9631 33.0003 2.9631ZM33.0003 66C14.8039 66 0.000244141 51.1954 0.000244141 33C0.000244141 14.8036 14.8039 0 33.0003 0C51.1968 0 65.9995 14.8036 65.9995 33C65.9995 51.1954 51.1968 66 33.0003 66Z"
          fill="#2E2E30"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.9999 44.7054L20.6921 35.7637L25.3936 21.2949H40.6062L45.3076 35.7637L32.9999 44.7054Z"
        fill="#4C4C4C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.4344 35.1964L32.9999 42.8728L43.5663 35.1964L39.5306 22.7761H26.4692L22.4344 35.1964ZM32.9999 46.1865C32.6947 46.1865 32.3885 46.0917 32.1287 45.904L19.821 36.9614C19.3024 36.5841 19.0851 35.9154 19.2837 35.3041L23.9832 20.8362C24.1827 20.2258 24.7516 19.813 25.3926 19.813H40.6062C41.2482 19.813 41.8171 20.2258 42.0156 20.8362L46.7171 35.3041C46.9146 35.9154 46.6973 36.5831 46.1788 36.9614L33.871 45.904C33.6113 46.0917 33.3061 46.1865 32.9999 46.1865Z"
        fill="#2E2E30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.3188 3.3418C16.0666 5.59375 10.735 9.76579 7.02917 15.1468L19.8545 14.0228L22.3188 3.3418Z"
        fill="#4C4C4C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2278 5.81305C16.4409 7.60276 13.0254 10.1984 10.2717 13.3749L18.6524 12.641L20.2278 5.81305ZM7.0291 16.6283C6.50463 16.6283 6.01473 16.3498 5.74904 15.8925C5.45964 15.3967 5.48335 14.7784 5.8083 14.3063C9.7601 8.5707 15.2962 4.29693 21.816 1.94818C22.3256 1.76348 22.8965 1.87312 23.3025 2.23363C23.7074 2.59414 23.8842 3.14626 23.7627 3.67468L21.2984 14.3557C21.1532 14.9809 20.6228 15.4421 19.9838 15.4984L7.15849 16.6224C7.11503 16.6264 7.07157 16.6283 7.0291 16.6283Z"
        fill="#2E2E30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.787 13.1704L56.3399 14.1008C53.9033 11.0874 50.9214 8.58453 47.5346 6.71185L48.787 13.1704ZM59.5263 17.4689C59.467 17.4689 59.4058 17.4649 59.3445 17.457L47.3568 15.9794C46.7197 15.9014 46.2061 15.4214 46.0836 14.7912L44.0588 4.35125C43.9541 3.81098 44.1576 3.25787 44.5853 2.91415C45.0149 2.57043 45.5977 2.49043 46.1024 2.7097C52.1333 5.32216 57.2061 9.63643 60.7727 15.1863C61.0829 15.6693 61.0858 16.2886 60.7806 16.7755C60.507 17.2101 60.032 17.4689 59.5263 17.4689Z"
        fill="#2E2E30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.8124 62.1656C30.818 63.4003 36.1516 63.3153 41.105 61.9246L33.2616 56.4913L25.8124 62.1656ZM32.9999 65.9999C29.2792 65.9999 25.6138 65.3776 22.1075 64.1509C21.5929 63.9702 21.2186 63.5227 21.1336 62.9835C21.0477 62.4452 21.265 61.9039 21.6986 61.573L32.3223 53.4818C32.833 53.0917 33.5352 53.0778 34.0636 53.4423L45.2257 61.173C45.676 61.4861 45.917 62.0214 45.8528 62.5657C45.7886 63.1099 45.4281 63.5751 44.9175 63.7726C41.105 65.2502 37.0959 65.9999 32.9999 65.9999Z"
        fill="#2E2E30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8581 37.7915L1.55194 30.9893C1.50947 31.655 1.48181 32.3236 1.48181 33.0002C1.48181 39.4331 3.41277 45.4126 6.72157 50.3995L10.8581 37.7915Z"
        fill="#4C4C4C"
      />
      <mask
        id="mask1_5830_72374"
        style={{maskType: 'alpha'}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="29"
        width="13"
        height="23"
      >
        <path d="M0 29.5073V51.8803H12.3393V29.5073H0H0Z" fill="white" />
      </mask>
      <g mask="url(#mask1_5830_72374)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.97533 33.8646C3.10472 38.412 4.25243 42.827 6.33352 46.8292L9.11489 38.3528L2.97533 33.8646ZM6.72169 51.8803C6.22981 51.8803 5.76362 51.6353 5.48706 51.2175C1.89676 45.8089 -0.000610352 39.5093 -0.000610352 32.9994C-0.000610352 32.2922 0.0300084 31.5929 0.0734673 30.8976C0.107049 30.3573 0.432991 29.8783 0.922891 29.6482C1.40983 29.418 1.98862 29.4724 2.42519 29.7934L11.7313 36.5956C12.2508 36.9739 12.4652 37.6436 12.2647 38.253L8.12916 50.861C7.95236 51.4003 7.48222 51.7904 6.92022 51.8674C6.85404 51.8753 6.78688 51.8803 6.72169 51.8803Z"
          fill="#2E2E30"
        />
      </g>
      <path fillRule="evenodd" clipRule="evenodd" d="M25.3931 21.2944L20.1711 14.4507Z" fill="#FEFEFE" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.3939 22.7768C24.9475 22.7768 24.5069 22.5763 24.2156 22.1941L18.9946 15.3503C18.4978 14.6994 18.6232 13.77 19.2731 13.2742C19.926 12.7774 20.8534 12.9028 21.3493 13.5537L26.5703 20.3965C27.0671 21.0474 26.9416 21.9768 26.2917 22.4726C26.0231 22.6781 25.707 22.7768 25.3939 22.7768Z"
        fill="#2E2E30"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M40.6066 21.2948L47.5383 14.5103Z" fill="#FEFEFE" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.6066 22.7765C40.2214 22.7765 39.8382 22.6283 39.5478 22.331C38.9759 21.7473 38.9848 20.809 39.5705 20.2361L46.5022 13.4516C47.085 12.8788 48.0243 12.8886 48.5971 13.4734C49.169 14.0581 49.1591 14.9964 48.5734 15.5683L41.6427 22.3538C41.3553 22.6353 40.981 22.7765 40.6066 22.7765Z"
        fill="#2E2E30"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M20.692 35.7632L10.8584 37.7909Z" fill="#FEFEFE" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8561 39.2731C10.1686 39.2731 9.55132 38.7911 9.40711 38.0908C9.24118 37.2888 9.75775 36.5056 10.5588 36.3406L20.3933 34.3129C21.1874 34.145 21.9786 34.6625 22.1435 35.4645C22.3095 36.2656 21.7929 37.0488 20.9919 37.2137L11.1573 39.2425C11.0566 39.2632 10.9558 39.2731 10.8561 39.2731Z"
        fill="#2E2E30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.8844 38.3518L59.6658 46.8282C61.7469 42.8271 62.8946 38.4121 63.024 33.8647L56.8844 38.3518ZM59.2786 51.8803C59.2124 51.8803 59.1463 51.8754 59.0801 51.8675C58.5171 51.7904 58.0479 51.4003 57.8711 50.861L53.7346 38.253C53.5331 37.6436 53.7485 36.974 54.268 36.5957L63.5731 29.7934C64.0107 29.4734 64.5885 29.42 65.0754 29.6472C65.5653 29.8773 65.8913 30.3554 65.9258 30.8957C65.9752 31.669 65.9999 32.3584 65.9999 32.9995C65.9999 39.5084 64.1025 45.8079 60.5132 51.2176C60.2367 51.6354 59.7705 51.8803 59.2786 51.8803Z"
        fill="#2E2E30"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M45.3077 35.7632L55.1413 37.7909Z" fill="#FEFEFE" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.1434 39.2733C55.0436 39.2733 54.9429 39.2634 54.8422 39.2427L45.0086 37.214C44.2076 37.049 43.691 36.2658 43.8569 35.4647C44.0219 34.6627 44.812 34.1462 45.6071 34.3131L55.4407 36.3408C56.2417 36.5058 56.7583 37.289 56.5924 38.091C56.4482 38.7913 55.8308 39.2733 55.1434 39.2733Z"
        fill="#2E2E30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.0002 56.1422C32.1824 56.1422 31.5187 55.4785 31.5187 54.6607V44.7057C31.5187 43.8879 32.1824 43.2241 33.0002 43.2241C33.818 43.2241 34.4818 43.8879 34.4818 44.7057V54.6607C34.4818 55.4785 33.818 56.1422 33.0002 56.1422Z"
        fill="#2E2E30"
      />
    </Icon>
  );
}
